import { useEffect, useState } from "react";
import { fetchClientById } from "../services/clients.service";

/**
 * Resolves a client id to its name, re-fetching whenever the id changes (e.g.
 * navigating from one client's profile straight to another's). Returns null
 * while loading, id-less, or on a fetch failure — callers should treat null
 * as "don't show anything" rather than an error state.
 */
export function useClientName(clientId: string | undefined): string | null {
  const [name, setName] = useState<string | null>(null);

  useEffect(() => {
    if (!clientId) {
      setName(null);
      return;
    }
    let cancelled = false;
    fetchClientById(clientId)
      .then((res: any) => { if (!cancelled) setName(res?.name ?? null); })
      .catch(() => { if (!cancelled) setName(null); });
    return () => { cancelled = true; };
  }, [clientId]);

  return name;
}
